<div class="py-4 pl-3 pr-4 flex flex-col items-center">           
    <img src='/assets/trendlines/LockSolid.png' class="w-[48px] h-[48px] justify-self-center mb-4"/>
    <div class="headline-small-strong text-center sm:text-xs">{{ bannerText }}</div>
    <button
        class="bg-dat-blue-500 font-headline-7 sm:text-xs rounded-full px-4 sm:px-3 py-2 mt-4"
        (click)="redirectToIqRateView()"
    >
        {{ 'Learn More' | uppercase }}
    </button>
</div>